<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div>
      <div class="box">
        <div class="downloadBox">
          <div class="logo">
            <img :src="datas.logo" alt="">
          </div>
          <div class="text">
            <span>{{datas.web_title}}</span>
            <span>为您提供全网优惠卷</span>
          </div>
          <div class="download" @click="jumpDownload()">
            <span>立即下载</span>
          </div>
        </div>
        <div class="particulars">
          <div class="swiperBox">
            <swiper :options="swiperOption" class="swiper">
              <swiper-slide v-for="(item, index) in invitation_img" :key="index" :class="{active:index === 0, shadow:true}">
                <!--<img :src="item.article_banner" style="width: 100%;height: 100%">-->
                <div @click="detail(item.id)">
                  <div class="banner">
                    <img :src="item" alt="">
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination" slot="pagination"></div>
          </div>
          <div class="explain">
            <div class="texts">{{datas.title}}</div>
            <div class="message">
              <div>
                <span class="pan1">￥</span>
                <span class="jiage">{{datas.itemprice}}</span>
              </div>
              <div class="quan">
                <span>券</span>
                <span>{{datas.couponmoney}}元</span>
              </div>
              <div class="sell">
                <span>已售：</span>
                <span>{{datas.itemsale}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="purchase" @click="purchase">
          淘口令购买
        </div>
        <div class="shade" v-show="shows">
          <div class="popUp">
            <div class="word">
              淘口令购买
              <span class="mistake" @click="shut">×</span>
            </div>
            <div class="copy">
              <span>长按选择>> </span>
              <span class="copys">拷贝</span>
            </div>
            <span class="code" id="code">{{datas.code}}</span>
            <div class="duplication" id="duplication"
                 v-clipboard:copy="datas.code"
                 v-clipboard:success="onCopy"
                 v-clipboard:error="onError">复制</div>
            <span class="sm">点击复制后，请打开【手机淘宝】购买!</span>
          </div>
        </div>
      </div>
      <!--<div class="show" v-show="win">-->
        <!--复制成功-->
      <!--</div>-->
      <a href="#" class="allow" v-show="codes">无效的code</a>
    </div>
</template>

<script>
import { Toast } from 'mint-ui'
import axios from 'axios'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'commodity',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      codes: false,
      datas: {},
      invitation_img: [],
      shows: false,
      // messages: 'aaa',
      win: false,
      swiperOption: {
        // height: 300,
        // effect: 'coverflow',
        autoplay: 3000,
        speed: 1000,
        // width: 100%,
        coverflowEffect: {
          rotate: 2,
          stretch: -20,
          depth: 80,
          modifier: 2,
          slideShadows: false
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          progressbarOpposite: true,
          bulletElement: 'li',
          dynamicBullets: false,
          dynamicMainBullets: 2,
          hideOnClick: false,
          clickable: true
        }
      }
    }
  },
  methods: {
    shut () {
      this.shows = false
    },
    purchase () {
      this.shows = true
    },
    onCopy (e) {
      Toast({
        message: '复制成功',
        className: 'coln'
      })
      let that = this
      this.cut = false
      this.shows = true
      // this.win = true
      window.setTimeout(refreshCount, 1000)
      function refreshCount () {
        // that.shows = false
        // that.win = false
        console.log(that.shows)
      }
    },
    onError (e) {
      console.error(e)
    },
    jumpDownload () {
      this.$router.push({
        path: '/download',
        query: {code: this.code}
      })
    }
  },
  mounted () {
    let code = this.GLOBAL.getQueryString('code')
    // let code = 'MV84NDA5XzU4OTI0Mjk3NjA2Ng=='
    if (!code) {
      this.codes = true
    }
    axios.get(this.GLOBAL.apiUrl + '/api/w1/share/goods?code=' + code).then((res) => {
      if (res.data.code === 0) {
        this.datas = res.data.data
        this.invitation_img = res.data.data.img
        document.title = res.data.data.title
      } else {
        this.$router.push('/download1')
      }
    })
  }
}
</script>
<style>
  .swiper-pagination-clickable .swiper-pagination-bullet{
    transform: scale(1);
  }
  .swiper-pagination{
    bottom: 0.2rem;
  }
  .swiper-pagination{
    left: 50%;
    transform: translateX(-50%);
    width: 200px
  }
  .swiper-pagination li{
    margin: 0 5px;
  }
  .swiper-pagination-bullet{
    opacity: 1;
    background-color: rgba(0,0,0,0.4);
  }
  .swiper-pagination-bullet-active{
    background-color: #007aff;
  }
  .swiper-pagination{
    width: 200px;
  }
  .mint-toast is-placemiddle{
    width: 4rem;
  }
  .coln{
    width: 2.8rem;
    height: 1.1rem;
    line-height: 1.1rem;
    /*padding: 0.3rem 0!important;*/
    margin-top: -0.2rem;
    background-color: rgba(0,0,0,0.6);
    color: #fff;
    /*background-color: #000;*/
    font-size: 0.32rem;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 0!important;
  }
</style>

<style scoped>
  .show{
    color: #fff;
    position: fixed;
    top: 273px;
    width: 120px;
    height: 40px;
    font-size: 13px;
    text-align: center;
    line-height: 40px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px;
    background-color: black;
    opacity: 0.7;
    /*display: none;*/
    z-index: 999;
  }
  .swiperBox {
    /*width: 100%;*/
    position: relative;
    height: 7.2rem;
    overflow: hidden;
  }
  .swiperBox .swiper {
    /*margin-top: 0.5rem;*/
  }
  .swiperBox .bgc {
    width: 100%;
    height: 2rem;
    position: absolute;
    top: -0.5rem;
    left: 0;
  }
  .swiperBox .bgc img {
    width: 100%;
    height: 100%;
  }
  .swiperBox .items {
    position: absolute;
    width: 0.80rem;
    height: 1.7rem;
    top: 1.14rem;
    right: 0.16rem;
  }
  .swiperBox .items .piece {
    width: 0.8rem;
    height: 0.8rem;
    color: red;
    font-size: 0.26rem;
    text-align: center;
    background-color: #fff;
    opacity: 0.7;
    border-radius: 4px;
  }
  .swiperBox .items .piece span {
    display: block;
  }
  .swiperBox .items .img {
    width: 0.8rem;
    height: 0.8rem;
    top: 0.1rem;
    position: relative;
  }
  .swiperBox .items .img img {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .banner {
    height: 7.2rem;
    width: 100%;
    background-color: #f7f7f7;
  }
  .banner img {
    width: 100%;
    /*height: 100%;*/
  }
  body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,textarea,p,blockquote,th,td,hr,button,article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section {
    margin:0;
    padding:0
  }
  .box{
    padding-bottom: 1.1rem;
  }
  .downloadBox{
    width: 100%;
    padding: 0.1rem 0.15rem;
    background-color: #4c4c4c;
    height: 1.0rem;
    box-sizing: border-box;
    overflow: hidden;
  }
  .logo{
    float: left;
    width: 0.80rem;
    height: 0.80rem;
    position: relative;
  }
  .logo img{
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .text{
    float: left;
    padding-left: 0.20rem;
    color: #fff;
  }
  .text span{
    display: block;
  }
  .text span:nth-child(1){
    font-size: 0.3rem;
    line-height: 0.5rem;
  }
  .text span:nth-child(2){
    font-size: 0.22rem;
    line-height: 0.3rem;
  }
  .download{
    float: right;
    padding: 0.1rem 0;
  }
  .download span{
    display: block;
    width: 1.80rem;
    height: 0.6rem;
    line-height: 0.6rem;
    border-radius: 0.1rem;
    text-align: center;
    font-size: 0.3rem;
    color: #fff;
    background-color: #fc3357;
  }

  .explain .texts{
    display: block;
    padding: 0 0.3rem;
    padding-top: 0.28rem;
    font-size: 0.3rem;
    color: black;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .message{
    overflow: hidden;
    margin-top: 0.3rem;
    padding: 0 0.2rem;
  }
  .message div{
    float: left;
  }
  .message div:nth-child(1){
    font-size: 0.3rem;
    color: #fc3357;
    font-weight: 800;
  }
  .pan1{
    font-size: 0.28rem;
    font-weight: bold;
  }
  .jiage{
    font-size: 0.45rem;
  }
  .quan{
    margin-left: 0.4rem;
    height: 0.4rem;
    border: 1px solid #fc3357;
    margin-top: 0.1rem;
  }
  .quan span:nth-child(1){
    font-size: 0.3rem;
    float: left;
    border-right: 1px solid #fc3357;
    padding: 0 0.04rem;
    color: #fff;
    background: linear-gradient(to right, #ff485f , #ffa880)
  }
  .quan span:nth-child(2){
    float: right;
    font-size: 0.24rem;
    padding: 0rem 0.16rem;
    line-height: 0.4rem;
    color: #fc3357;
  }
  .message .sell{
    line-height: 0.6rem;
    float: right;
    font-size: 0.22rem;
    color: #c2c2c2;
  }
  .purchase{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    line-height: 1.0rem;
    display: block;
    font-size: 0.3rem;
    color: #fff;
    text-align: center;
    text-decoration:none;
    background-color: #fc3357;
  }
  .popUp{
    border-radius: 9px;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 3.74rem;
    width: 6rem;
    height: 5.88rem;
  }
  .shade{
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.8);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
  }
  .popUp{
    background-color: #fff;
  }
  .word{
    border-top-left-radius:8px;
    border-top-right-radius:8px;
    height: 1rem;
    width: 100%;
    font-size: 0.3rem;
    text-align: center;
    line-height: 1rem;
    background-color: #fc3357;
    color: #fff;
  }
  .mistake{
    position: absolute;
    top: -2.2px;
    right: 0px;
    font-size: 0.6rem;
    width: 46px;
    /*height: 12px;*/
  }
  .copy{
    position: absolute;
    font-size: 0.22rem;
    color: #666;
    width: 3.30rem;
    height: 0.5rem;
    background-color: #ffe8e6;
    border-radius: 4px;
    margin: 0.4rem  auto;
    text-align: center;
    line-height: 0.5rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
    top: 0.8rem;
  }
  .copy span:nth-child(2){
    color: #fc3357;
  }
  .code{
    position: relative;
    margin: 0.4rem;
    height: 1.2rem;
    line-height: 1.5rem;
    border: 1px dashed #fc3357;
    text-align: center;
    font-size: 0.32rem;
    color: black;
    font-weight: 800;
    display: block;
    margin-top: 0.4rem;
  }
  .duplication{
    height: 0.76rem;
    width: 3rem;
    margin: 0.5rem auto;
    font-size: 0.32rem;
    color: #fff;
    background-color: #fc3357;
    border-radius: 21px;
    text-align: center;
    line-height: 0.76rem;
  }
  .sm{
    font-size: 0.22rem;
    color: #7d5a5a;
    display: block;
    margin: 0 0.8rem;
    text-align: center;
  }
  .show{
    color: #fff;
    position: fixed;
    top: 273px;
    width: 120px;
    height: 40px;
    font-size: 13px;
    text-align: center;
    line-height: 40px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px;
    background-color: black;
    opacity: 0.7;
    /*display: none;*/
    z-index: 999;
  }
  .swiper-container {
    /*height: 420px;*/
  }
  .swiper-slide img{
    width: 100%;
    height: 100%;
  }
  a{
    text-decoration:none;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/goods.vue